import { createSelector } from '@reduxjs/toolkit'
import { getMoments, getMomentById } from '../../getters/entities/moments'

export const selectMoments = createSelector(
  [getMoments],
  (moments) => moments || null
)

export const selectMomentById = createSelector(
  [getMomentById],
  (moment) => moment
)
